import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { ISponsoredAuthor } from 'src/app/core/dtos/interfaces/i-sponsored-author-dto';
import { ISponsoredAuthorFormGroup } from '../../interfaces/i-sponsored-author-form-group';

@Component({
  selector: 'app-sponsored-author-section',
  templateUrl: './sponsored-author-section.component.html',
  styleUrls: ['./sponsored-author-section.component.scss'],
})
export class SponsoredAuthorSectionComponent {
  @Input() sponsoredAuthorsControl: FormArray<FormControl<ISponsoredAuthor>>;
  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;

  sponsoredAuthorForm: FormGroup<ISponsoredAuthorFormGroup>;
  isSponsoredAuthorFormVisible: boolean = false;
  isEditMode = false;
  isNew = false;

  initSponsoredAuthorForm() {
    let index =
      this.sponsoredAuthorsControl.length > 0
        ? this.sponsoredAuthorsControl.length + 1
        : 0;

    this.sponsoredAuthorForm = new FormGroup(
      {
        name: new FormControl(null),
        title: new FormControl(null),
        companyName: new FormControl(null),
        index: new FormControl(index),
      },
      { validators: this.nameValidator() }
    );
    this.isNew = true;
    this.toggleSponsoredAuthorForm();
  }

  addSponsoredAuthor() {
    this.sponsoredAuthorsControl.push(
      new FormControl(this.sponsoredAuthorForm.getRawValue())
    );
    this.isNew = false;
    this.toggleSponsoredAuthorForm();
  }

  onEditSponsoredAuthor(item: ISponsoredAuthor) {
    let index = this.sponsoredAuthorsControl.value.findIndex(
      (x) => x.name == item.name
    );
    this.sponsoredAuthorForm = new FormGroup(
      {
        name: new FormControl<string>(item.name),
        title: new FormControl<string>(item.title),
        companyName: new FormControl<string>(item.companyName),
        index: new FormControl<number>(index),
      },
      { validators: this.nameValidator() }
    );

    this.toggleSponsoredAuthorForm();
  }

  editSponsoredAuthor() {
    const authorToUpdate = this.sponsoredAuthorForm.getRawValue();

    this.sponsoredAuthorsControl.controls[authorToUpdate.index].patchValue({
      name: authorToUpdate.name,
      companyName: authorToUpdate.companyName,
      title: authorToUpdate.title,
    });
    this.toggleSponsoredAuthorForm();
  }

  onRemove(item: ISponsoredAuthor) {
    let indexToRemove = this.sponsoredAuthorsControl.value.findIndex(
      (x) => x.name == item.name
    );
    if (indexToRemove > -1) {
      this.sponsoredAuthorsControl.removeAt(indexToRemove);
    }
  }

  toggleSponsoredAuthorForm() {
    this.isSponsoredAuthorFormVisible = !this.isSponsoredAuthorFormVisible;
    this.isEditMode = !this.isEditMode;
  }

  nameValidator() {
    return (form: FormGroup) => {
      form.get('name').markAsTouched();
      const error =
        (!form.get('name').value || form.get('name').value === '') &&
        form.get('title').value
          ? { required: true }
          : null;
      form.get('name').setErrors(error);
      return error;
    };
  }

  cancelEditAuthorForm() {
    this.isNew = false;
    this.toggleSponsoredAuthorForm();
  }

  isSaveButtonDisabled() {
    let form = this.sponsoredAuthorForm.getRawValue();
    if (this.sponsoredAuthorForm.invalid) {
      return true;
    }

    return false;
  }
}
